import { log } from '../../services/utils';

import { controller } from '../../contexts/TagsContext';

import { noraApiRequest } from './';

export const getTagList = async typeId => {
	log( '* get tag list' );
	const { data } = await noraApiRequest( {
		url: '/labels',
		params: { typeId },
		signal: controller.signal
	} );

	return data;
};

export const getTag = async id => {
	log( '* get tag' );
	const { data } = await noraApiRequest( {
		url: `/labels/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createTag = async data => {
	log( '* create tag' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/labels',
		data
	} );

	return response.data;
};

export const updateTag = async data => {
	log( '* update tag' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/labels',
		data
	} );

	return response.data;
};

export const deleteTag = async id => {
	log( '* delete tag' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/labels/${ id }`
	} );

	return response.data;
};
